// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const V1Neo4jServerHealthType = {
  Neo4jServerHealthAvailable: 'Available',
  Neo4jServerHealthUnavailable: 'Unavailable',
} as const;
export type V1Neo4jServerHealthType =
  (typeof V1Neo4jServerHealthType)[keyof typeof V1Neo4jServerHealthType];

export function instanceOfV1Neo4jServerHealthType(value: any): boolean {
  for (const key in V1Neo4jServerHealthType) {
    if (Object.prototype.hasOwnProperty.call(V1Neo4jServerHealthType, key)) {
      if (
        V1Neo4jServerHealthType[key as keyof typeof V1Neo4jServerHealthType] ===
        value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function V1Neo4jServerHealthTypeFromJSON(
  json: any,
): V1Neo4jServerHealthType {
  return V1Neo4jServerHealthTypeFromJSONTyped(json, false);
}

export function V1Neo4jServerHealthTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1Neo4jServerHealthType {
  return json as V1Neo4jServerHealthType;
}

export function V1Neo4jServerHealthTypeToJSON(
  value?: V1Neo4jServerHealthType | null,
): any {
  return value as any;
}

export function V1Neo4jServerHealthTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): V1Neo4jServerHealthType {
  return value as V1Neo4jServerHealthType;
}
